import Joi from 'joi'
import errorsResolver from '../../../../validation/schemeUtils'
import {config} from "../../../../helpers/config";

const warningCheckingForInvalidCharacters = `Поле ввода содержит некорректные символы`
const incorrectInsertionValue = `Вставка содержит некорректные символы`
const amountMax = 99999999.99
const maxMakeOfCarLength = 100
const maxModelLength = 100
const maxCarNumberLength = 10
const minCarNumberLength = 7
const registrationNumberLength = 150
const VINLength = 17
const conditionLength = 1500
const ADD_INFO_FIELD_LENGTH = 38
const IMEI_LENGTH = config().validatePurities ? 15 : 100;
const SN_LENGTH = config().validatePurities ? 25 : 100;
const NAME_LENGTH = config().validatePurities ? 40 : 200;
const MODEL_LENGTH = config().validatePurities ? 32 : 150;

export const thingsSchema = Joi.object({
    positions: Joi.array().items(
        Joi.object({
            imei: Joi.string()
                .max(IMEI_LENGTH)
                .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.+-,!{}#()$%^&*~_/,№:?”`\\- ]*$'))
                .allow('')
                .error(errorsResolver({
                    max: `IMEI должно быть до ${IMEI_LENGTH} символов`,
                    pattern: warningCheckingForInvalidCharacters
                })),
            model: Joi.string()
                .max(MODEL_LENGTH)
                .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.+-,!{}#()$%^&*~_/,№:?”`\\- ]*$'))
                .allow('')
                .error(errorsResolver({
                    max: `Модель должно быть до ${MODEL_LENGTH} символов`,
                    pattern: warningCheckingForInvalidCharacters
                })),
            names: Joi.string()
                .max(NAME_LENGTH)
                .required()
                .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.+,!{}#()$%^&*~_/,№:?”`\\[\\]\\- ]*$'))
                .error(errorsResolver({
                    max: `Наименование должно быть до ${NAME_LENGTH} символов`,
                    pattern: warningCheckingForInvalidCharacters,
                    required: `Наименование обязательное поле`,
                })),
            positionId: Joi.number()
                .error(errorsResolver({
                    number: 'Должно быть число',
                })),
            quantity: Joi.number()
                .error(errorsResolver({
                    number: 'Количество обязательноe поле или должно быть числом',
                })),
            serialNumber: Joi.string()
                .max(SN_LENGTH)
                .allow('')
                .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.+-,!{}#()$%^&*~_/,№:?”`\\- ]*$'))
                .error(errorsResolver({
                    max: `Модель должно быть до ${SN_LENGTH} символов`,
                    pattern: warningCheckingForInvalidCharacters
                })),
            estimatedValue: Joi.number()
                .max(amountMax)
                .required()
                .error(errorsResolver({
                    number: `Должно быть число`,
                    max: `Не более ${amountMax}`
                })),
            additionalInfo: Joi.string()
                .allow('')
                .max(ADD_INFO_FIELD_LENGTH)
                .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.+-,-!()_/,№:?”;" ]*$'))
                .error(errorsResolver({
                    pattern: warningCheckingForInvalidCharacters,
                    max: `Длина доп. описания должна быть меньше или равна ${ADD_INFO_FIELD_LENGTH} символам`,
                })),
        })
    )
})

export const puritiesSchema = (configure) => {
    const NAME_FIELD_LENGTH = configure ? 20 : 60
    const COMMENT_FIELD_LENGTH = configure ? 14 : 90
    const ADD_INFO_FIELD_LENGTH = configure ? 20 : 90
    const IS_PART_NAME_LENGTH = configure ? 21 : 60;

    return Joi.object({
        positions: Joi.array().items(
            Joi.object({
                comment: Joi.string()
                    .max(COMMENT_FIELD_LENGTH)
                    .allow('')
                    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.+\\-,!( )_:?";\\n]*$'))
                    .error(errorsResolver({
                        max: `Вставка должна быть до ${COMMENT_FIELD_LENGTH} символов`,
                        pattern: incorrectInsertionValue
                    })),
                grossWeight: Joi.number()
                    .error(errorsResolver({
                        number: 'Общий вес обязательно поле или должен быть числом',
                    })),
                names: Joi.when('isPart', {
                    is: true,
                    then: Joi.object({
                        label: Joi.string()
                            .max(IS_PART_NAME_LENGTH)
                            .required()
                            .error(errorsResolver({
                                max: `Наименование должно быть до ${IS_PART_NAME_LENGTH} символов`,
                                required: `Наименование обязательное поле`,
                            })),
                        part: Joi.any(),
                        value: Joi.number()
                            .error(errorsResolver({
                                required: `Наименование обязательное поле`,
                                number: `Должно быть число`
                            }))
                    }),
                    otherwise: Joi.object({
                        label: Joi.string()
                            .max(NAME_FIELD_LENGTH)
                            .required()
                            .error(errorsResolver({
                                max: `Наименование должно быть до ${NAME_FIELD_LENGTH} символов`,
                                required: `Наименование обязательное поле`,
                            })),
                        part: Joi.any(),
                        value: Joi.number()
                            .error(errorsResolver({
                                required: `Наименование обязательное поле`,
                                number: `Должно быть число`
                            }))
                    })
                })
                    .required()
                    .error(errorsResolver({
                        invalid: `Наименование обязательное поле`,
                        required: `Наименование обязательное поле`,
                    }))
                    .invalid(null)
                    .error(errorsResolver({
                        includesRequiredUnknowns: `Наименование обязательное поле`
                    })),
                positionId: Joi.number()
                    .allow(null)
                    .empty('')
                    .error(errorsResolver({
                        number: `Должно быть число`
                    })),
                pureWeight: Joi.number()
                    .required()
                    .invalid(-0, 0, "-")
                    .max(Joi.ref('grossWeight'))
                    .precision(2)
                    .error(errorsResolver({
                        number: 'Лигатурный вес обязательно поле или должен быть числом',
                        max: 'Лигатурный вес должен быть не больше общего веса',
                        invalid: 'Лигатурный вес не может быть равен 0 или -',
                        required: 'Лигатурный вес обязательное поле',
                    })),
                purityId: Joi.number()
                    .error(errorsResolver({
                        number: `Должно быть число`
                    })),
                quantity: Joi.number()
                    .error(errorsResolver({
                        number: `Количество обязательно поле или должно быть числом`
                    })),
                purityPrice: Joi.number()
                    .error(errorsResolver({
                        number: `Должно быть число`
                    })),
                isPart: Joi.bool(),
                showComment: Joi.bool(),
                additionalInfo: Joi.string()
                    .allow('')
                    .max(ADD_INFO_FIELD_LENGTH)
                    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.+-,-!()_/,№:?”;" ]*$'))
                    .error(errorsResolver({
                        max: `Длина доп. описания должна быть меньше или равна ${ADD_INFO_FIELD_LENGTH} символам`,
                        pattern: warningCheckingForInvalidCharacters
                    })),
                purityName: Joi.string(),
                purityType: Joi.string(),
                prevPositionId: Joi.string().allow(''),
                estimatedValue: Joi.number()
            })
        )
    })
}

export const carsEditSchema = Joi.object({
    positions:
        Joi.array().items(
            Joi.object({
                makeOfCar: Joi.object({
                    value: Joi.string()
                        .required()
                        .max(maxMakeOfCarLength)
                        .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ\\-()/" ]{1,${maxMakeOfCarLength}}$`))
                        .error(errorsResolver({
                            required: 'Марка авто обязательное поле',
                            max: `Поле не должно иметь больше ${maxMakeOfCarLength} символов`,
                            pattern: warningCheckingForInvalidCharacters,
                        })),
                    label: Joi.string()
                        .required()
                        .max(maxMakeOfCarLength)
                        .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ0-9\\-()/" ]{1,${maxMakeOfCarLength}}$`))
                        .error(errorsResolver({
                            required: 'Марка авто обязательное поле',
                            max: `Поле не должно иметь больше ${maxMakeOfCarLength} символов`,
                            pattern: warningCheckingForInvalidCharacters,
                        })),
                }).invalid(null)
                    .required()
                    .min(1)
                    .error(errorsResolver({
                        invalid: `Марка авто обязательное поле`,
                        required: `Марка авто обязательное поле`,
                        min: `Марка авто обязательное поле`
                    })),
                positionId: Joi.number()
                    .error(errorsResolver({
                        number: `Должно быть число`
                    })),
                model: Joi.object({
                    value: Joi.string()
                        .required()
                        .max(maxModelLength)
                        .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ0-9\\-()/" ]{1,${maxModelLength}}$`))
                        .error(errorsResolver({
                            required: 'Модель авто обязательное поле',
                            max: `Поле не должно иметь больше ${maxModelLength} символов`,
                            pattern: warningCheckingForInvalidCharacters,
                        })),
                    label: Joi.string()
                        .required()
                        .max(maxModelLength)
                        .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ0-9\\-()/" ]{1,${maxModelLength}}$`))
                        .error(errorsResolver({
                            required: 'Модель авто обязательное поле',
                            max: `Поле не должно иметь больше ${maxModelLength} символов`,
                            pattern: warningCheckingForInvalidCharacters,
                        })),
                }).invalid(null)
                    .required()
                    .min(1)
                    .error(errorsResolver({
                        invalid: `Модель авто обязательное поле`,
                        required: `Модель авто обязательное поле`,
                        min: `Модель авто обязательное поле`
                    })),
                year: Joi.object({
                    label: Joi.number()
                        .error(errorsResolver({
                            number: `Год выпуска обязательное поле`
                        })),
                    value: Joi.number()
                        .error(errorsResolver({
                            number: `Год выпуска обязательное поле`
                        }))
                })
                    .invalid(null)
                    .required()
                    .error(errorsResolver({
                        invalid: `Год выпуска обязательное поле`,
                        required: `Год выпуска обязательное поле`
                    })),
                carNumber: Joi.string()
                    .max(maxCarNumberLength)
                    .min(minCarNumberLength)
                    .required()
                    .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ0-9\\- ]{${minCarNumberLength},${maxCarNumberLength}}$`))
                    .error(errorsResolver({
                        required: 'Гос. номер обязательное поле',
                        max: `Поле не должно иметь больше ${maxCarNumberLength} символов`,
                        min: `Поле должно быть не менее ${minCarNumberLength} символов`,
                        pattern: warningCheckingForInvalidCharacters,
                    })),
                quantity: Joi.number()
                    .min(1)
                    .max(1)
                    .error(errorsResolver({
                        numberMin: 'Количество должно быть больше 0',
                        max: `Количество должно быть не больше 1`,
                        numberUnsafe: 'Некорректное число'
                    })),
                estimatedPrice: Joi.number()
                    .min(0.01)
                    .empty('')
                    .error(errorsResolver({
                        numberBase: 'Оценочная стоимость должна быть числом',
                        numberMin: 'Оценочная стоимость должна быть больше 0',
                        numberUnsafe: 'Некорректное число'
                    })),
                marketPrice: Joi.number()
                    .min(0.01)
                    .empty('')
                    .error(errorsResolver({
                        numberBase: 'Оценочная стоимость должна быть числом',
                        numberMin: 'Оценочная стоимость должна быть больше 0',
                        numberUnsafe: 'Некорректное число'
                    })),
                registrationNumber: Joi.string()
                    .max(registrationNumberLength)
                    .required()
                    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.+-,!{}#()$%^&*~_/,№:?"`\\- ]*$'))
                    .error(errorsResolver({
                        required: 'Номер свид. регистрации обязательное поле',
                        max: `Поле не должно иметь больше ${registrationNumberLength} символов`,
                        pattern: warningCheckingForInvalidCharacters,
                    })),
                registrationDate: Joi.date()
                    .iso()
                    .required()
                    .error(errorsResolver({
                        dateFormat: `Некорректная дата`,
                        required: 'Дата выдачи свид. регистрации обязательное поле',
                    })),
                VIN: Joi.string()
                    .max(VINLength)
                    .min(VINLength)
                    .required()
                    .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ0-9]{${VINLength},${VINLength}}$`))
                    .error(errorsResolver({
                        max: `VIN номер должен содержать ${VINLength} символов`,
                        min: `VIN номер должен содержать ${VINLength} символов`,
                        required: 'VIN номер обязательное поле',
                        pattern: warningCheckingForInvalidCharacters,
                    })),
                garage: Joi.string()
                    .required()
                    .error(errorsResolver({
                        required: `Выберите хранение или без хранения в ломбарде`,
                    })),
                condition: Joi.string()
                    .required()
                    .max(conditionLength)
                    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.+-,!{}#()$%^&*~_/,№:?"`\\-\\n\\r ]*$'))
                    .error(errorsResolver({
                        required: `Состояние ТС обязательное поле`,
                        max: `Длина комментария должна быть меньше или равна ${conditionLength} символам`,
                        pattern: warningCheckingForInvalidCharacters,
                    })),
            })
        )
})
